import translate from "./i18n";
import recommends from "./recommendBlocks";

export default {
	data() {
		return {
			blocks: recommends.blocks
		};
	},
	i18n: {
		...translate
	},
};
